var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_vm._v(" 豫ICP备17049494号-1 "),_c('br'),_vm._v(" Powered by "+_vm._s(_vm.dateYear)+" 汽车出口价 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }